<template lang="pug">
.login
  .section
    .container
      .columns.is-centered
        .column.is-full-mobile.is-paddingless
          .block-center(
            v-tooltip="{content: errors.server.message, show: errors.server.message}"
          )
            h2 {{ gettext('Login') }}
            .field
              .field-body.has-icon
                i.mdi.mdi-account
                input(
                  type='email'
                  name='email'
                  v-model='form.email'
                  :class="{'is-danger': $v.form.email.$error }"
                  @focus="$v.form.email.$touch()"
                  @keyup.enter="send"
                  :placeholder="gettext('User email')")
            .field
              .field-body.has-icon
                i.mdi.mdi-lock
                input(
                  type='password'
                  name='password'
                  v-model='form.password'
                  :class="{'is-danger': $v.form.password.$error }"
                  @focus="$v.form.password.$touch()"
                  @keyup.enter="send"
                  :placeholder="gettext('Password')")
            .field
              .field-body
                button.main-btn.col-white.bg-red(@click='send' :disabled="!formIsValid") {{ gettext('Log in') }}
            transition(name="bounce")
              div(v-if="termsError")
                .field.is-horizontal
                  .field-body {{ gettext('Terms of use of the service have been changed, for login, you must accept the new terms of use.')}}
                .field.is-horizontal
                  label.label
                  .field-body
                    input#custom-checkbox.is-checkradio.is-danger.custom-checkbox(type="checkbox" v-model="form.agree")
                    label.checkbox(for="custom-checkbox")
                      | {{ gettext('I agree to the') }} &nbsp;
                      router-link(:to="`/${getLanguage}/terms-and-conditions`") {{ gettext('terms and conditions') }}

            .field
              .field-body.link-field
                router-link.link-black(:to="`/${getLanguage}/forgot-password`") {{ gettext('Forgot password?') }}
            .field(v-if="showRestoreAccount")
              .field-body.link-field
                label.label.name.center-text {{ gettext('Your account was deleted. Do you want restore it?') }}
            .field(v-if="showRestoreAccount")
              .field-body.link-field
                router-link.link-black(:to="`/${getLanguage}/restore-account`") {{ gettext('Restore Account?') }}

              label.label.is-hidden-mobile

            .has-text-centered
              h2 {{ gettext('Are you still not with us?') }}
              .field
                .field-body
                  router-link.main-btn.col-white.bg-red.btn-big(:to="`/${getLanguage}/registration`" tag="button") {{ gettext('Create an account') }}
        .column.is-ful-mobile.left-border.is-paddingless
          .block-center
            h2 {{ gettext('Or log in with social networks') }}
            social-login(
              :social="social"
              :nextError="`/${getLanguage}/login`"
              :nextLogin="`/-hook/social-auth-login?next_login=/${getLanguage}/profile`"
              :nextSignup="`/-hook/social-auth-login?next_signup=/${getLanguage}/profile`"
            )
            .field
              .field-body.link-field.margined
                | {{ gettext('Not a user yet?') }} &nbsp;
                router-link.link-red(:to="`/${getLanguage}/registration`") {{ gettext('Create an account') }}
</template>

<script>
import Vue from 'vue'
import { gettext } from '@/services/TranslateHandler'
import { mapActions, mapGetters } from 'vuex'
import Vuelidate from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'
import VTooltip from 'v-tooltip'
import mixin from '@/mixins'
import AccessMixin from '@/mixins/AccessMixin'
import SocialLogin from '@/components/social-login'
const _ = require('lodash')
const inactive = require('@/constants.json')
const toastr = require('toastr')

Vue.use(Vuelidate)
Vue.use(VTooltip, {
  defaultTrigger: 'manual'
})

export default {
  name: 'Login',
  mixins: [
    mixin,
    AccessMixin
  ],
  components: {
    SocialLogin
  },
  metaInfo () {
    return this.getMetaInfoMixin({defaultMetaInfo: this.defaultMetaInfo})
  },
  data () {
    return {
      inactive: inactive,
      form: {
        email: '',
        password: '',
        rememberMe: true,
        agree: undefined
      },
      showRestoreAccount: false,
      termsError: false,
      errors: {},
      social: {}
    }
  },
  validations: {
    form: {
      email: {
        email,
        required
      },
      password: {
        required
      }
    }
  },
  methods: {
    ...mapActions([
      'login',
      'socialLoginInfo'
    ]),
    gettext: gettext,
    send () {
      let redirect = this.redirectAccess(this.$route.query.redirect) ? `/${this.getLanguage}/profile` : this.$route.query.redirect
      this.login({
        lang: this.getLanguage,
        email: this.form.email,
        password: this.form.password,
        rememberMe: this.form.rememberMe,
        agree: this.form.agree,
        redirect: redirect
      }).catch(err => {
        if (err.data.form_errors) {
          this.errorProcessor(err.data.form_errors)
        }
        if (err.code === 3012) {
          this.termsError = true
        }
        if (err.code === 3014) {
          this.showRestoreAccount = true
        }
      })
    },
    errorProcessor (error) {
      _.each(error, (item) => {
        this.$set(this.errors.server, 'message', item[0].message)
        this.$v.$touch()
      })
    },
    setErrorsText () {
      this.errors = {
        server: {}
      }
    },
    async setSocialLinks () {
      this.social = await this.socialLoginInfo()
    },
    showMessages () {
      if (this.$route.query.deletedAccount) {
        toastr.success(gettext('Your account has been deleted!'), gettext('Success!'))
        this.$router.push({name: 'Login'})
      }
      if (this.$route.query.deletedSocialAccount) {
        toastr.success(gettext('Your account has been deleted!'), gettext('Success!'))
      }
      if (this.$route.query.restoredAccount) {
        toastr.success(gettext('Your account has been restored! Now you can log in.'), gettext('Success!'))
        this.$router.push({name: 'Login'})
      }
    }
  },
  watch: {
    getLanguage: function () {
      this.setErrorsText()
    }
  },
  created () {
    this.setSocialLinks()
    this.setErrorsText()
    this.showMessages()
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ]),
    defaultMetaInfo () {
      return {
        title: 'Bixter | ' + gettext('Login'),
        titleTemplate: null,
        link: [
          { rel: 'canonical', href: document.location.origin + document.location.pathname }
        ]
      }
    },
    formIsValid: function () {
      return !this.$v.$invalid
    }
  }
}
</script>

<style lang="scss" src="./styles.scss" scoped></style>



// WEBPACK FOOTER //
// src/pages/auth/login/index.vue